import JobApplicationHeader from './JobApplicationHeader.component';

export default JobApplicationHeader;